import FetchUtils from 'src/utils/fetch_utils';

const REQUEST_DOCUMENT_LINK_SELECTOR = '.js-showing-view-request-documents-btn';
const PHONE_REQUIRED_MESSAGE = 'Please provide a phone number';

function requestDocumentLinkFrom(target) {
  return target.closest?.(REQUEST_DOCUMENT_LINK_SELECTOR);
}

function phoneInputFor(link) {
  const popup = link.closest('.js-showing-view-popup');
  return popup?.querySelector('.js-showing-view-edit-inline:not(.hidden) #showing_phone');
}

function showingHasPhone(popup) {
  return popup.dataset.showingPhonePresent === 'true';
}

function stopRequest(e) {
  e.preventDefault();
  e.stopPropagation();
}

function dispatchRailsUjsEvent(link, eventName) {
  link.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
}

function submitRequestDocument(link, phone) {
  dispatchRailsUjsEvent(link, 'ajax:beforeSend');

  fetch(link.href, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      async: 'true',
      'x-csrf-token': FetchUtils.CSRFToken()
    },
    body: JSON.stringify({ phone })
  }).then((response) => FetchUtils.checkResponseStatus(response))
    .then(() => dispatchRailsUjsEvent(link, 'ajax:success'))
    .catch((err) => FetchUtils.handleResponseError(err))
    .finally(() => dispatchRailsUjsEvent(link, 'ajax:complete'));
}

/**
 * On ajax:success for request-documents button, replace it with "Documents requested" status.
 */
export function initRequestDocumentReload(popup) {
  if (popup.dataset.requestDocumentReloadBound === 'true') {
    return;
  }
  popup.dataset.requestDocumentReloadBound = 'true';

  popup.addEventListener('click', (e) => {
    const link = requestDocumentLinkFrom(e.target);
    if (!link || !popup.contains(link)) return;

    const phoneInput = phoneInputFor(link);
    if (phoneInput) {
      stopRequest(e);
      if (phoneInput.value.trim() === '') {
        alert(PHONE_REQUIRED_MESSAGE);
        return;
      }
      submitRequestDocument(link, phoneInput.value);
      return;
    }

    if (!showingHasPhone(popup)) {
      stopRequest(e);
      alert(PHONE_REQUIRED_MESSAGE);
    }
  });

  popup.addEventListener('ajax:success', (e) => {
    const link = requestDocumentLinkFrom(e.target);
    if (link) {
      link.replaceWith(
        Object.assign(document.createElement('span'), {
          className: 'showing-view-popup__request-documents-status js-showing-view-request-documents-status',
          textContent: 'Documents requested'
        })
      );
    }
  });
}
